import { PermissionMiddleware } from '../permissionInterface';

export function createOrganizationPermissionsMiddleware(): PermissionMiddleware[] {
    return [];
}
